import { GeneralAPI } from '../apis/GeneralAPI'
import Header from '../components/Header'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import Hero from '../components/RealEstateInvestorsLanding/Hero'
import SocialProof from '../components/RealEstateInvestorsLanding/SocialProof'
import CampaignStrategy from '../components/RealEstateInvestorsLanding/CampaignStrategy'
import WhyOLM from '../components/RealEstateInvestorsLanding/WhyOLM'
import HowItWorks from '../components/RealEstateInvestorsLanding/HowItWorks'
import FAQ from '../components/RealEstateInvestorsLanding/FAQ'
import BookingSection from '../components/RealEstateInvestorsLanding/BookingSection'
import Footer from '../components/Footer'

export default function RealEstateInvestors({ data }) {
    return (
        <LandingPageWrapper sectionSpacing={false} paddingFromTop={false}>
            <Header meta={data?.yoast_head} />
            <Hero />
            <SocialProof />
            <CampaignStrategy />
            <WhyOLM />
            <HowItWorks />
            <FAQ />
            <BookingSection />
            <Footer />

            <style
                dangerouslySetInnerHTML={{
                    __html: `
                @media (max-width: 640px) {
                    .roofers-form-grid {
                        grid-template-columns: 1fr !important;
                        padding: 20px !important;
                        gap: 16px !important;
                    }
                    .roofers-form-footer {
                        justify-content: center !important;
                        text-align: center;
                    }
                    .roofers-form-footer button {
                        width: 100%;
                    }
                }
            `,
                }}
            />
        </LandingPageWrapper>
    )
}

export async function getStaticProps() {
    let data = {}

    try {
        const page = await GeneralAPI.getPageBySlug('/real-estate-investors')
        data = page ? page[0] || {} : {}
    } catch (e) {
        console.error(e)
    }

    try {
        const { banners } = await GeneralAPI.getACFBanners()
        data.banners = banners
    } catch (e) {
        console.error(e)
    }

    return {
        props: {
            data,
            phoneNumber: '978-893-5890',
        },
        revalidate: 10,
    }
}
